import React from 'react';
import { map, pick } from 'lodash';
import moment, { isMoment } from 'moment';
import * as PropTypes from 'prop-types';
import {
  PERSONAL_DATA_FIELD_KEYS,
  PERSONAL_TABLE_DATA_TITLE,
} from 'modules/Profile/components/PersonalData/constants';
import DateFormats from 'constants/DateFormats';
import { InfoTable, InfoTableRow } from 'modules/Contacts/components/Appointment/InfoTable';
import styles from './PersonalDataTable.module.scss';

export default function PersonalDataTable({ personalData, inn }) {
  const tableData = { ...personalData, inn, fullName: getFullName(personalData) };
  const fields = getPersonalDataFields(tableData);
  return (
    <InfoTable>
      {fields.map((field, index) => (
        <InfoTableRow
          key={index}
          title={field.title}
          value={field.value}
          className={styles.profileTable}
        />
      ))}
    </InfoTable>
  );
}
PersonalDataTable.propTypes = {
  personalData: PropTypes.object,
  inn: PropTypes.string,
};

function getFullName(personalData) {
  const { lastName, firstName, middleName } = personalData;
  let fullName = '';
  if (lastName) {
    fullName += lastName;
  }
  if (firstName) {
    fullName += ` ${firstName}`;
  }
  if (middleName) {
    fullName += ` ${middleName}`;
  }
  return fullName;
}

function getPersonalDataFields(personalData) {
  return map(pick(personalData, PERSONAL_DATA_FIELD_KEYS), (value, field) => {
    return {
      title: PERSONAL_TABLE_DATA_TITLE[field],
      value: getValue(value),
    };
  });
}

function getValue(value) {
  if (isMoment(value)) {
    return value.isSame(moment('01-01-1900', DateFormats.long))
      ? '-'
      : value.format(DateFormats.long);
  } else {
    return value || '—';
  }
}
